import React from 'react';
import styled from 'styled-components';
import { ReactComponent as WarningIcon } from './warningIcon.svg';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: #faf2b3;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 12px;
  margin-top: 15px;
  gap: 8px;

  font-size: 13px;
  font-style: normal;
  line-height: 18.2px;
`;

const Bold = styled.span`
  font-weight: 700;
`;

export const OrganizationWarning: React.FC = () => {
  return (
    <Wrapper>
      <WarningIcon />
      <div>
        <Bold>Set Organization:</Bold> The delivery of this game’s data will be delayed if the organization is not set.
      </div>
    </Wrapper>
  );
};
